import { render, staticRenderFns } from "./PortalOperadora.vue?vue&type=template&id=2354a972&"
import script from "./PortalOperadora.vue?vue&type=script&lang=js&"
export * from "./PortalOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports